import React from 'react';
import PropTypes from 'prop-types';
import QRCode from 'qrcode.react';

const BrandInfo = (props) => {
  const {
    url = '',
    brandUrl = '',
    logo = '',
    boxStyle = {},
  } = props;
  const style = Object.assign({}, {
  }, boxStyle);
  return (
    <div style={style} className="flex flex-col">
      <div className="self-center h-1/2">
        <img src={logo} alt="" />
      </div>
      <div className="self-center h-1/2">
        <QRCode value={`${url || brandUrl}`} size={80} padding={10} />
      </div>
    </div>
  );
};
BrandInfo.propTypes = {
  url: PropTypes.string,
  brandUrl: PropTypes.string,
  logo: PropTypes.string,
  boxStyle: PropTypes.object,
};
BrandInfo.defaultProps = {
  url: '',
  brandUrl: '',
  logo: '',
  boxStyle: {},
};

export {
  // eslint-disable-next-line import/prefer-default-export
  BrandInfo,
};



// WEBPACK FOOTER //
// ./src/components/brand/index.js